import { connect } from 'react-redux';

import API from './API';

import { getPLPData } from 'shared/store/listingV2/services';
import { getIsFetching } from 'shared/store/listingV2/selectors';

const mapDispatchToProps = {
  getPLPData,
};

const mapStateToProps = (state: any) => ({
  isFetching: getIsFetching(state),
});
export default connect(mapStateToProps, mapDispatchToProps)(API);
